import React from "react";
import {AxiosError} from "axios";
import {type ToastOptions} from "react-toastify"

function defaultHandleAPIError(error: AxiosError | string | { errMsg?: string } | Error) {
  console.error(error);
}

function defaultToast(message: string, type: ToastOptions['type'] = 'success') {
  switch (type) {
    case 'info':
      console.info(message);
      break
    case 'error':
      console.error(message);
      break;
    case 'warning':
      console.warn(message);
      break;
    default:
      console.info(message, type);
  }
}

export const HandleAPIErrorContext = React.createContext(defaultHandleAPIError);
export const ToastContext = React.createContext(defaultToast);
